import { render, staticRenderFns } from "./PurchaseOrderOrderReceipt.vue?vue&type=template&id=2835d60b&scoped=true"
import script from "./PurchaseOrderOrderReceipt.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOrderReceipt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOrderReceipt.vue?vue&type=style&index=0&id=2835d60b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835d60b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2835d60b')) {
      api.createRecord('2835d60b', component.options)
    } else {
      api.reload('2835d60b', component.options)
    }
    module.hot.accept("./PurchaseOrderOrderReceipt.vue?vue&type=template&id=2835d60b&scoped=true", function () {
      api.rerender('2835d60b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderOrderReceipt.vue"
export default component.exports